@if (!isNetworkAvailable()) {
  <div class="no-internet-toastr-wrap" [ngClass]="{ closed: !showOfflineMessage }">
    <div class="no-network-non-closable" (click)="toggleOfflineMessage()">
      <tds-icon name="'wifi_inactive'" [size]="'1.8rem'" class="me-1"></tds-icon>
      <span>{{ 'DuÄrOffline' | translate }}</span>
    </div>
    @if (showOfflineMessage) {
      <div class="no-network-closable">
        <div>
          <!-- Check your internet connection. -->
          <p>{{ 'KontrolleraDinInternetanslutning_' | translate }}</p>
        </div>
        <span (click)="toggleOfflineMessage()">
          <tds-icon name="'close'" [size]="'1.8rem'"></tds-icon>
        </span>
      </div>
    }
  </div>
}
